import React from 'react';
import { useMediaList } from '#hooks/use-media-list.js';

export function useGallery({
    initialData,
    onAdd,
    onAddImage,
    onEdit,
    onUpload,
    onDelete,
    stateless,
    setState,
    setUnsavedChanges
}) {
    const [activeImage, setActiveImage] = React.useState(null);
    const [modal, setModal] = React.useState(false);

    const onDeleteImage = React.useCallback(
        (images, id) => {
            if (activeImage && activeImage.id === id) setActiveImage(null);
            if (typeof onDelete === 'function') onDelete(images, id);
        },
        [activeImage, onDelete]
    );

    const { data, ...mediaHandlers } = useMediaList({
        initialData,
        onDelete: onDeleteImage,
        onAdd,
        onAddImage,
        onEdit,
        onUpload,
        stateless,
        setState,
        setUnsavedChanges
    });

    React.useEffect(() => {
        if (/* !activeImage && */ data) {
            setActiveImage(data?.[0]);
        }
    }, [data]);

    const showSelectedImage = React.useCallback(
        (id) => {
            setActiveImage(data.find((image) => image.id === id) ?? null);
        },
        [data, setActiveImage]
    );

    const showPrevImage = React.useCallback(() => {
        setActiveImage((active) => {
            if (!active) return data.find(() => true);
            const image = data.find((_, i) => i === data.findIndex((image) => image.id === active.id) - 1);
            return image ?? data.at(-1);
        });
    }, [data, setActiveImage]);

    const showNextImage = React.useCallback(() => {
        setActiveImage((active) => {
            if (!active) return data.find(() => true);
            const image = data.find((_, i) => i === data.findIndex((image) => image.id === active.id) + 1);
            return image ?? data[0];
        });
    }, [data, setActiveImage]);

    const showModal = () => setModal((state) => !state);

    return {
        gallery: data,
        ...mediaHandlers,
        activeImage,
        setActiveImage,
        showSelectedImage,
        showPrevImage,
        showNextImage,
        showModal,
        modal
    };
}
